module.exports = __webpack_public_path__ + "static/media/ico_speaker.5ff595d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ico_speaker.svg
// module id = 470
// module chunks = 1